import React, { Component } from 'react'
import extend from 'lodash/extend'
import { SearchkitManager,SearchkitProvider,
  SearchBox, RefinementListFilter, Pagination,
  HierarchicalMenuFilter, HitsStats, SortingSelector, NoHits,
  ResetFilters, RangeFilter, NumericRefinementListFilter,
  ViewSwitcherHits, ViewSwitcherToggle, DynamicRangeFilter,
  InputFilter, GroupedSelectedFilters,
  Layout, TopBar, LayoutBody, LayoutResults,
  ActionBar, ActionBarRow, SideBar } from 'searchkit'
import './index.css'

//const host = "http://demo.searchkit.co/api/movies"
//const host = "http://localhost:9200/movies/movie"
//const searchkit = new SearchkitManager(host)

const host = "https://mentes-3192305613.us-east-1.bonsaisearch.net:443/products2"

const searchkit = new SearchkitManager(host, 
  //https://github.com/searchkit/searchkit/issues/698
  { 
  searchUrlPath : "_search?rest_total_hits_as_int=true",
  httpHeaders:{},
  basicAuth:"i8t7rit5p5:4z5iqcnsik"
})

const MovieHitsGridItem = (props)=> {
  const {bemBlocks, result} = props
  let url = "https://glutenerzekeny.hu/glutenmentes-akcios-lista-2020-december/"
  const source = extend({}, result._source, result.highlight)  
  return (
    <div className={bemBlocks.item().mix(bemBlocks.container("item"))} data-qa="hit">
      <a se_id="name" href={url} target="_blank">
        <img data-qa="image" className={bemBlocks.item("image")} src={result._source.image}/>
        <div data-qa="name" className={bemBlocks.item("name")} dangerouslySetInnerHTML={{__html:source.name}}></div>
      </a>
    </div>
  )
}

const MovieHitsListItem = (props)=> {
  const {bemBlocks, result} = props
  let url = "https://glutenerzekeny.hu/glutenmentes-akcios-lista-2020-december/"
  const source = extend({}, result._source, result.highlight)
  return (
    <div className={bemBlocks.item().mix(bemBlocks.container("item"))} data-qa="hit">
      <div className={bemBlocks.item("image")}>
        <img data-qa="image" src={result._source.image}/>
      </div>
      <div className={bemBlocks.item("details")}>
        <a se_id="title" href={url} target="_blank"><h2 className={bemBlocks.item("title")} dangerouslySetInnerHTML={{__html:source.name}}></h2></a>
        <h3 className={bemBlocks.item("subtitle")}>Released in {source.name}, rated {source.name}/10</h3>
        <br/>
        <div className={bemBlocks.item("text")} dangerouslySetInnerHTML={{__html:source.plot}}></div>
      </div>
    </div>
  )
}

class App extends Component {
  render() {
    return (
      <SearchkitProvider searchkit={searchkit}>
        <Layout>
          <TopBar>
            <div className="my-logo">Mentes</div>
            <SearchBox autofocus={true} searchOnChange={true} prefixQueryFields={["name^2"]}/>
          </TopBar>

        <LayoutBody>

          <SideBar>
            <RefinementListFilter id="place" title="place" field="countries" operator="OR" size={10}/>
            <NumericRefinementListFilter id="price" title="Length" field="price" options={[
              {title:"All"},
              {title:"up to 200", from:0, to:200},
              {title:"201 to 600", from:201, to:600},
              {title:"6001 or more", from:6001, to:10000}
            ]}/>
          </SideBar>
          <LayoutResults>
            <ActionBar>

              <ActionBarRow>
                <HitsStats translations={{
                  "hitstats.results_found":"{hitCount} results found in {timeTaken}ms"
                }}/>
                <ViewSwitcherToggle/>
                <SortingSelector options={[
                  {label:"Relevance", field:"_score", order:"desc"},
                  {label:"period_start", field:"period_start", order:"desc"},
                  {label:"period_end", field:"period_end", order:"asc"}
                ]}/>
              </ActionBarRow>

              <ActionBarRow>
                <GroupedSelectedFilters/>
                <ResetFilters/>
              </ActionBarRow>

            </ActionBar>
            <ViewSwitcherHits
                hitsPerPage={32} highlightFields={["title","plot"]}
                sourceFilter={["name", "image", "place", "orig_price"]}
                hitComponents={[
                  {key:"grid", title:"Grid", itemComponent:MovieHitsGridItem, defaultOption:true},
                  {key:"list", title:"List", itemComponent:MovieHitsListItem}
                ]}
                scrollTo="body"
            />
            <NoHits suggestionsField={"name"}/>
            <Pagination showNumbers={true}/>
          </LayoutResults>

          </LayoutBody>
        </Layout>
      </SearchkitProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js